module.exports = __webpack_public_path__ + "img/SV.5b14da72.png";